import { useState, useEffect } from 'react';

// `src` can be a single URL or an ordered list of candidate URLs — the first
// one that actually loads wins; if none do, `fallback` is used.
const useImageExists = (src, fallback) => {
  const sources = (Array.isArray(src) ? src : [src]).filter(Boolean);
  const sourcesKey = sources.join('|');
  const [imgSrc, setImgSrc] = useState(sources[0] || fallback);

  useEffect(() => {
    let cancelled = false;

    if (!sources.length) {
      setImgSrc(fallback);
      return undefined;
    }

    const tryLoad = (index) => {
      if (index >= sources.length) {
        if (!cancelled) setImgSrc(fallback);
        return;
      }

      const img = new Image();
      img.onload = () => {
        if (!cancelled) setImgSrc(sources[index]);
      };
      img.onerror = () => tryLoad(index + 1);
      img.src = sources[index];
    };

    tryLoad(0);

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourcesKey, fallback]);

  return imgSrc;
};

export default useImageExists;
